import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import {
  filterElement,
  filtersConfig,
  MAIN_REGIONS_OPTIONS_QUERY_KEY,
} from '~/features/BookingCars/ListBookingCars/config'
import { Region } from '~/shared/api'
import { Option } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { IonCheckbox as Checkbox } from '~/shared/ui/form/Checkbox'
import { ChevronDownIcon, GeopointIcon } from '~/shared/ui/icons'
import { useFiltersQueryParams } from '~/shared/ui/ScrollableList'
import { myPalette } from '~/shared/ui/theme'
import { Title, Wrapper } from './styled'

const { brandModel, price, location, region, taxipark } = filterElement

export function RegionsFilter() {
  const [isShow, openDrawer, closeDrawer] = useDrawer()
  const [filtersQuery, setFiltersQuery] = useFiltersQueryParams(filtersConfig)

  const regionCode = filtersQuery[region.field]?.id
  const regionLabel = filtersQuery[region.field]?.label
  const taxiparkId = filtersQuery[taxipark.field]?.id

  const handleOnChange = (option: Option) => {
    closeDrawer()
    setFiltersQuery(
      {
        [region.field]: regionCode === option.id ? undefined : option,
        [price.option.fromField]: undefined,
        [price.option.toField]: undefined,
        [brandModel.first.field]: undefined,
        [brandModel.second.field]: undefined,
        [location.field]: undefined,
      },
      'replaceIn',
    )
  }

  const { isFetching, isLoading, isPreviousData, data } = useQuery<Option[]>(
    [MAIN_REGIONS_OPTIONS_QUERY_KEY, taxiparkId],
    () =>
      Region.fetchOptions(
        taxiparkId,
        !taxiparkId ? [{ key: 'allRegions', value: 'true' }] : undefined,
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )

  const isPending = isLoading || (isFetching && isPreviousData)

  const options = useMemo(() => data ?? [], [data])

  return (
    <div>
      <Button
        startDecorator={<GeopointIcon />}
        endDecorator={
          <div style={{ transform: 'rotate(-90deg)' }}>
            <ChevronDownIcon color={myPalette.white.main} />
          </div>
        }
        disabled={isPending}
        loading={isPending}
        variant='textLink'
        onClick={openDrawer}
        contentProps={{ style: { padding: '0' } }}
        style={{
          '--color': 'white',
          fontSize: '14px',
          height: '30px',
        }}
      >
        {regionLabel || 'Выберите регион'}
      </Button>
      <DrawerComponent isShow={isShow} onCancel={closeDrawer}>
        <Wrapper>
          <Title>Выбор региона</Title>

          {!options.length && <div>Ошибка получения регионов</div>}

          {options.map((option) => (
            <Checkbox
              onClick={() => handleOnChange(option)}
              key={option.id}
              labelPlacement='end'
              justify='start'
              checked={option?.id === regionCode}
            >
              {option.label}
            </Checkbox>
          ))}
        </Wrapper>
      </DrawerComponent>
    </div>
  )
}
